module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/electric/gas-stove-75df55fe77162258d715530906d15d99.svg";